import { render, staticRenderFns } from "./TwoDirectionPosition.vue?vue&type=template&id=3c46b5f2&"
import script from "./TwoDirectionPosition.vue?vue&type=script&lang=js&"
export * from "./TwoDirectionPosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports